import TemplatesList from "./TemplatesList";
export default TemplatesList;
